/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Credential_Connect_CtaInputs */

const vi_einvoice_credential_connect_cta = /** @type {(inputs: Einvoice_Credential_Connect_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kết nối MISA`)
};

/**

* @param {Einvoice_Credential_Connect_CtaInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_credential_connect_cta = /** @type {((inputs?: Einvoice_Credential_Connect_CtaInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Credential_Connect_CtaInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_credential_connect_cta(inputs)
});